"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var qrcode_react_1 = __importDefault(require("qrcode.react"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var core_1 = require("@21st-night/core");
require("react-image-crop/dist/ReactCrop.css");
var ActionButtons_1 = __importDefault(require("../../../ActionButtons"));
var Button_1 = __importDefault(require("../../../Button"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            backgroundColor: '#F0F4F8',
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        qrWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        code: {
            textAlign: 'right',
        },
        link: {
            color: '#47A3F3',
            textDecoration: 'none',
        },
        mobileUploadInstructions: {
            display: 'flex',
            alignItems: 'center',
            margin: theme.spacing(0, 1),
        },
        mobileUploadInstructionsInner: {
            flex: 1,
        },
        qrCode: {
            marginRight: theme.spacing(3),
        },
        explanation: {
            maxWidth: 300,
        },
    });
});
var EditorInsertImageFromMobile = function (_a) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    var _b = core_1.useFirebase(), db = _b.db, userId = _b.userId;
    var classes = exports.useStyles();
    var editor = slate_react_1.useEditor();
    var _c = __read(react_1.useState(''), 2), mobileUploadId = _c[0], setMobileUploadId = _c[1];
    var _d = __read(react_1.useState(core_1.generateShortId(5)), 1), mobileUploadCode = _d[0];
    var path = slate_react_1.ReactEditor.findPath(editor, element);
    function onUploadSuccess(url, id) {
        slate_1.Transforms.setNodes(editor, {
            type: 'image-uploaded',
            cropped: false,
            id: id,
            url: url,
        }, { at: path });
    }
    function handleCancel() {
        slate_1.Transforms.removeNodes(editor, { at: path });
    }
    function handleMobileUpload() {
        if (userId) {
            var ref = db
                .collection('users')
                .doc(userId)
                .collection('mobile-uploads')
                .doc();
            setMobileUploadId(ref.id);
            ref.set({
                isMobileUpload: true,
                status: 'pending',
                isComplete: false,
                code: mobileUploadCode,
                createdAt: new Date(),
            });
            ref.onSnapshot(function (snapshot) {
                if (snapshot.exists) {
                    var data = snapshot.data();
                    if (data && data.status === 'complete') {
                        var url = data.url, fileId = data.fileId;
                        onUploadSuccess(url, fileId);
                    }
                }
            });
        }
    }
    react_1.useEffect(function () {
        handleMobileUpload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    core_1.useWindowUnloadEffect(function () {
        if (mobileUploadId && userId) {
            db.collection('users')
                .doc(userId)
                .collection('mobile-uploads')
                .doc(mobileUploadId)
                .delete();
        }
        return null;
    });
    return (react_1.default.createElement("div", __assign({ className: classes.root }, attributes),
        react_1.default.createElement("div", { contentEditable: false },
            react_1.default.createElement("div", { className: classes.mobileUploadInstructions },
                react_1.default.createElement(qrcode_react_1.default, { bgColor: "#F0F4F8", size: 100, value: process.env.REACT_APP_BASE_URL + "/photo", className: classes.qrCode }),
                react_1.default.createElement("div", { className: classes.mobileUploadInstructionsInner },
                    react_1.default.createElement(Typography_1.default, { color: "textSecondary", variant: "h5", className: classes.code }, mobileUploadCode),
                    react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", className: classes.explanation },
                        "Open",
                        ' ',
                        react_1.default.createElement("a", { href: "https://app.get21stnight.com/photo", target: "_blank", rel: "noopener noreferrer", className: classes.link }, "app.get21stnight.com/photo"),
                        ' ',
                        "on your phone and tap on the button with the matching code."),
                    react_1.default.createElement(ActionButtons_1.default, { align: "end" },
                        react_1.default.createElement(Button_1.default, { variant: "text", size: "small", onClick: handleCancel }, "Cancel"))))),
        react_1.default.createElement("div", null, children)));
};
exports.default = EditorInsertImageFromMobile;
//# sourceMappingURL=EditorInsertImageFromMobile.js.map